export default "__VITE_ASSET__DyDWdG4D__"